import type { TranslationMessages } from '../types';

export const campaigns: TranslationMessages = {
  title: 'Campaigns',
  subtitle: 'Manage and track your business campaigns',
  new_campaign: 'New Campaign',
  edit_campaign: 'Edit Campaign',
  create_campaign: 'Create Campaign',
  update_campaign: 'Update Campaign',
  campaign_details: 'Campaign Details',
  loading: 'Loading campaigns...',
  loading_campaign: 'Loading campaign...',
  no_campaigns: 'No campaigns yet. Create your first campaign!',
  no_results: 'No campaigns found matching your search.',
  search_placeholder: 'Search campaigns...',
  delete_confirm: 'Are you sure you want to delete this campaign?',
  delete_error: 'Failed to delete campaign',
  load_error: 'Failed to load campaigns',
  save_error: 'Failed to save campaign',
  name: 'Campaign Name',
  name_required: 'Campaign Name *',
  name_placeholder: 'e.g., Pivot Trà sữa 90-day Campaign',
  description: 'Description',
  description_placeholder: 'Describe your campaign goals and strategy...',
  start_date: 'Start Date',
  start_date_required: 'Start Date *',
  end_date: 'End Date',
  end_date_required: 'End Date *',
  target_revenue: 'Target Revenue (VND)',
  target_category_revenue: 'Target Category Revenue (VND)',
  active: 'Campaign is active',
  saving: 'Saving...',
  create_subtitle: 'Create a new campaign to track performance',
  update_subtitle: 'Update campaign details',
  status: {
    active: 'Active',
    inactive: 'Inactive',
    upcoming: 'Upcoming',
    ended: 'Ended',
  },
  actions: {
    report: 'Report',
    edit: 'Edit',
    delete: 'Delete',
  },
  fields: {
    target: 'Target',
  },
  select_categories: 'Select Product Categories',
  select_categories_description:
    'Limit this campaign to specific product categories. Leave empty to include all categories.',
  search_categories: 'Search categories...',
  loading_categories: 'Loading categories...',
  no_categories: 'No categories found',
  select_products: 'Select Products',
  select_products_description:
    'Limit this campaign to specific products. Leave empty to include all products.',
  search_products: 'Search products...',
  loading_products: 'Loading products...',
  no_products: 'No products found',
  };
